import { Segmented } from 'antd';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import ConditionPage from './Condition/Condition.page';
import Organizationpage from './Organization/Organization.page';
import AllPractitionersPage from './Practitioner/AllPractitioners.page';
import Specialtypage from './Specialty/Specialty.page';

import {
  getAllConditionsListSlice,
  getAllSpecialtiesListSlice,
} from 'src/modules/SuperAdmin/store/slices';
import { getAllActiveOrganizationAction } from 'src/modules/SuperAdmin/store/actions/organization.action';
import ManageUsersPage from './ManageUsers/ManageUsers.page';
import { getFromStorage, storeInLocal } from '../../../../../lib/storage';
import OrganizationFilter from './OrganizationFilter';

const SuperAdmin = () => {
  const [activeButton, setActiveButton] = useState(() => {
    return getFromStorage('superAdminActiveSegment') || 'Organization';
  });

  const [isPractitionerHomePage, setIsPractitionerHomePage] = useState(true);
  const [
    selectedPractitionerOrganizationName,
    setSelectedPractitionerOrganizationName,
  ] = useState(null);
  const [
    selectedPractitionerOrganization,
    setSelectedPractitionerOrganization,
  ] = useState(null);
  const [
    selectedPractitionerOrganizationId,
    setSelectedPractitionerOrganizationId,
  ] = useState(null);
  const dispatch = useDispatch();

  // Load organization data when component mounts
  useEffect(() => {
    dispatch(getAllActiveOrganizationAction());
  }, [dispatch]);

  const superAdminButton = [
    {
      label: 'Organization',
    },
    {
      label: 'Practitioners',
    },
    {
      label: 'Specialty',
    },
    {
      label: 'Condition',
    },
    {
      label: 'Manage users',
    },
    {
      label: 'Questionnaire',
    },
  ];

  const handleSegmentedTabChange = (value) => {
    setIsPractitionerHomePage(true);
    setActiveButton(value);
    dispatch(getAllSpecialtiesListSlice(null));
    dispatch(getAllConditionsListSlice(null));
    storeInLocal('superAdminActiveSegment', value);
  };
  const shouldShowSuperAdmin =
    activeButton !== 'Condition' && activeButton !== 'Specialty';
  return (
    <div className={`page-wrapper`}>
      {shouldShowSuperAdmin && (
        <OrganizationFilter shouldShowSuperAdmin={shouldShowSuperAdmin} />
      )}
      <div className="lg:flex gap-3 justify-between py-3 items-center ">
        <Segmented
          options={superAdminButton.map((button) => ({
            label: button.label,
            value: button.label,
          }))}
          value={activeButton}
          onChange={(value) => {
            handleSegmentedTabChange(value);
          }}
        />
      </div>
      <div>
        {activeButton === 'Organization' && (
          <>
            <Organizationpage
              setActiveButton={setActiveButton}
              setIsPractitionerHomePage={setIsPractitionerHomePage}
              setSelectedPractitionerOrganizationName={
                setSelectedPractitionerOrganizationName
              }
              setSelectedPractitionerOrganizationId={
                setSelectedPractitionerOrganizationId
              }
              setSelectedPractitionerOrganization={
                setSelectedPractitionerOrganization
              }
            />
          </>
        )}
        {activeButton === 'Specialty' && (
          <>
            <Specialtypage />
          </>
        )}
        {activeButton === 'Condition' && (
          <>
            <ConditionPage />
          </>
        )}
        {activeButton === 'Practitioners' && (
          <>
            <AllPractitionersPage
              isHome={isPractitionerHomePage}
              selectedPractitionerOrganizationName={
                selectedPractitionerOrganizationName
              }
              selectedPractitionerOrganization={
                selectedPractitionerOrganization
              }
              selectedPractitionerOrganizationId={
                selectedPractitionerOrganizationId
              }
            />
          </>
        )}
        {activeButton === 'Manage users' && (
          <>
            <ManageUsersPage />
          </>
        )}
      </div>
    </div>
  );
};

export default SuperAdmin;
